module.exports = __webpack_public_path__ + "static/img/joinus_v2.57b7e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_spin/joinus_v2.png
// module id = xj+G
// module chunks = 6